module.exports = __webpack_public_path__ + "static/media/Ekle.96b28d05.png";